import { Types, types } from '../types'
import { callReportActions } from '../types/callReport/actionTypes'

const initialState = {
  getCallReportPending: false,
  getCallReportSuccess: false,
  getCallReportError: '',
  reportList: {},

  callQueueReportPending: false,
  callQueueReportSuccess: false,
  callQueueReportError: '',
  dataCallQueue: [],

  getUrlPending: false,
  getUrlSuccess: false,
  getUrlError: '',
  url: null,

  getCallReportNamePending: false,
  getCallReportNameSuccess: false,
  getCallReportNameError: '',
  reportNameList: {},
}

const callReportReducer = (state = initialState, action: callReportActions) => {
  switch (action.type) {
    case Types.GET_CALL_REPORT_REQUEST: {
      return {
        ...state,
        getCallReportPending: true,
        getCallReportSuccess: false,
        getCallReportError: '',
      }
    }
    case Types.GET_CALL_REPORT_SUCCESS: {
      return {
        ...state,
        getCallReportPending: false,
        getCallReportSuccess: true,
        getCallReportError: '',
        reportList: action.payload?.params,
      }
    }
    case Types.GET_CALL_REPORT_ERROR: {
      return {
        ...state,
        getCallReportPending: false,
        getCallReportSuccess: false,
        getCallReportError: action?.payload,
      }
    }

    case Types.RESET_GET_CALL_REPORT: {

      return {
        ...state,
        getCallReportPending: false,
        getCallReportSuccess: false,
        getCallReportError: '',
        reportList: {},
      }
    }

    //callQueu
    case Types.GET_CALL_QUEUE_REPORT_REQUEST: {
      return {
        ...state,
        callQueueReportPending: true,
        callQueueReportSuccess: false,
        callQueueReportError: '',
        dataCallQueue: [],
      }
    }
    case Types.GET_CALL_QUEUE_REPORT_SUCCESS: {
      return {
        ...state,
        callQueueReportPending: false,
        callQueueReportSuccess: true,
        callQueueReportError: '',
        dataCallQueue: action?.payload?.params,
      }
    }
    case Types.GET_CALL_QUEUE_REPORT_ERROR: {
      return {
        ...state,
        callQueueReportPending: false,
        callQueueReportSuccess: false,
        callQueueReportError: action?.payload,
      }
    }
    //get url

    case Types.GET_RECORD_URL_LIST_REQUEST: {
      return {
        ...state,
        getUrlPending: true,
        getUrlSuccess: false,
        getUrlError: '',
        url: null,
      }
    }
    case Types.GET_RECORD_URL_LIST_SUCCESS: {
      return {
        ...state,
        getUrlPending: false,
        getUrlSuccess: true,
        getUrlError: '',
        url: action?.payload,
      }
    }
    case Types.GET_RECORD_URL_LIST_ERROR: {
      return {
        ...state,
        getUrlPending: false,
        getUrlSuccess: false,
        getUrlError: action?.payload,
      }
    }
    // get name
    case Types.GET_CALL_REPORT_NAME_REQUEST: {
      return {
        ...state,
        getCallReportNamePending: true,
        getCallReportNameSuccess: false,
        getCallReportNameError: '',
        reportNameList: {},
      }
    }
    case Types.GET_CALL_REPORT_NAME_SUCCESS: {
      return {
        ...state,
        getCallReportNamePending: false,
        getCallReportNameSuccess: true,
        getCallReportNameError: '',
        reportNameList: action?.payload?.params,
      }
    }
    case Types.GET_CALL_REPORT_NAME_ERROR: {
      return {
        ...state,
        getCallReportNamePending: false,
        getCallReportNameSuccess: false,
        getCallReportNameError: action?.payload,
      }
    }

    default:
      return state
  }
}

export default callReportReducer
